import {DocumentInfo} from "../models/general/DocumentInfo.model";

/* tslint:disable */

export const NEWS: DocumentInfo[] = [
  {
    name: "IPIB Blocks Release of DMPD Bodycam Video",
    link: "https://twitter.com/DMRegister/status/1661009118482804736?s=20",
    description: "IPIB blocks release of video from controversial shooting of a 16-year old by DMPD.",
    date: "05/23/2023",
  },
  {
    name: "IPIB has a new executive director",
    link: "https://iowacapitaldispatch.com/2023/03/29/iowa-public-information-board-has-a-new-executive-director/",
    description: "In 2022, the IPIB staff processed 131 formal complaints and 130 informal complaints. The board did not initiate any contested cases in 2022, 2021, 2020 and 2019.",
    date: "03/29/2023",
  },
  {
    name: "Board to scrap proposed open records rules, for now",
    link: "https://www.bleedingheartland.com/2022/07/21/board-to-scrap-proposed-open-records-rules-for-now/",
    description: "IPIB will not move forward with proposed administrative rules regard requests for now.",
    date: "07/21/2022",
  },
  {
    name: "IPIB Drafts New Open Recrods Exemptions",
    link: "https://www.bleedingheartland.com/2022/07/14/transparency-advocates-sound-alarm-about-draft-open-records-rules/",
    description: "Longtime advocates for access to public records in Iowa expressed concern about new administrative rules proposed by the Iowa Public Information Board.",
    date: "07/15/2022",
  },
  {
    name: "IPIB dismisses Mills County public records case ",
    link: "https://www.kmaland.com/news/ipib-dismisses-mills-county-public-records-case/article_2928846a-a6da-11ec-99b7-23a90736bd67.html",
    description: "An Iowa board has dismissed a public records case regarding multiple Mill County officials.",
    date: "03/18/2022",
  },
  {
    name: "IPIB Dismisses Complaint Over Deleted Texts",
    link: "https://iowacapitaldispatch.com/2022/03/17/board-dismisses-complaint-over-deleted-cellphone-texts/?fbclid=IwAR1U2QdNPKbn58iHhzaGbVCX2JUiHSABR_-BJC_ZBqi5W66eMoqZ_HTfRCc",
    description: "The Iowa Public Information Board dismissed a complaint involving deleted cellphone texts at their 3/17/22 meeting.",
    date: "03/17/2022",
  },
  {
    name: "State lawyer: Iowa Workforce Development violated public records law",
    link: "https://iowacapitaldispatch.com/2022/02/09/state-lawyer-iowa-workforce-development-violated-public-records-law/",
    description: "State Lawyer concedes that Iowa Workforce Development violated public records law, but IPIB is looking to dismiss the complaint anyway.",
    date: "02/09/2022",
  },
  {
    name: "Adam Klein v. Iowa Public Information Board and Burlington Police Department and Iowa Department of Public Safety, Division of Criminal Investigations, 20-0657",
    link: "https://www.courtlistener.com/opinion/5313012/adam-klein-v-iowa-public-information-board-and-burlington-police/",
    description: "Court Documents about case involving IPIB.",
    date: "12/30/21",
  },
  {
    name: "State board rules IDPH violated records law, but dismisses complaint",
    link: "https://iowacapitaldispatch.com/2021/08/19/state-board-rules-idph-violated-records-law-but-dismisses-complaint/?fbclid=IwAR3yxEhCkyYfK9A7fAOUkH14vLLFFDPIef64DyC1tPH-NvJal80_0Q4sUms",
    description: "The Iowa Public Information Board on Thursday ruled that there was “probable cause” to believe the state health department violated the state’s open records law, then dismissed the complaint anyway.",
    date: "08/19/2021",
  },
  {
    name: "State panel tables open-records complaints against public health agency",
    link: "https://iowacapitaldispatch.com/2021/07/15/state-panel-tables-open-records-complaints-against-public-health-agency/",
    description: "The Iowa Public Information Board voted Thursday to delay any action on two public-records complaints involving the Iowa Department of Public Health while the department crafts a new policy on responding to information requests.",
    date: "07/15/2021",
  },
  {
    name: `Iowa Public Information Board dismisses claims that Indianola officials' gatherings were 'illegal and nefarious'`,
    link: "https://www.desmoinesregister.com/story/news/local/indianola/2021/06/24/iowa-board-dismisses-allegations-against-indianola-city-council-officials-mayor-pamela-pepper/5299387001/",
    description: "The Iowa Public Information Board dismissed accusations against the city of Indianola last week by two former political candidates and the city's former mayor, Kelly Shaw, alleging the city had broken open meetings laws.",
    date: "06/24/2021",
  },
  {
    name: "Appointment of DHS spokesman to public records board under fire",
    link: "https://www.desmoinesregister.com/story/news/2020/03/04/appointment-iowa-agency-spokesman-records-board-sparks-concerns/4954668002/",
    description: `Gov. Kim Reynolds on Wednesday appointed the spokesman for the Iowa Department of Human Services to the board that enforces the state’s public records law, a move criticized as a way to make it easier to deny access to information about the troubled agency.`,
    date: "03/04/2020",
  },
  {
    name: "Fighting City Hall on the State Level",
    link: "https://www.bleedingheartland.com/2019/12/24/fighting-city-hall-on-the-state-level/",
    description: `Involves complaint IPIB Complaint the Board of Corrections.`,
    date: "12/24/2019",
  },
  {
    name: "ACLU sues Iowa Public Information Board over Autumn Steele records",
    link: "https://www.thegazette.com/crime-courts/aclu-sues-iowa-public-information-board-over-autumn-steele-records/",
    description: `The American Civil Liberties Union of Iowa has filed a lawsuit seeking review of a decision by the Iowa Public Information Board that two law enforcement agencies did not break the law by keeping secret the body camera video and other records of a 2015 officer-involved fatal shooting in Burlington.`,
    date: "03/25/2019",
  },
  {
    name: "Public Information Board backs police on withholding records in Autumn​ Steele shooting",
    link: "https://www.desmoinesregister.com/story/news/crime-and-courts/2019/02/22/iowa-open-records-fatal-police-shooting-public-information-board-division-criminal-investigation/2953759002/",
    description: `IPIB sided with law enforcement in a struggle over police records regarding an officer's accidental shooting of a woman in 2015.`,
    date: "02/22/2019",
  },
  {
    name: "IPIB dismisses complaint against Indian Hills ",
    link: "https://www.ottumwacourier.com/news/ipib-dismisses-complaint-against-indian-hills/article_12e76d06-23e3-11e9-b6be-af6acd085715.html",
    description: `The Iowa Public Information Board has in a split vote dismissed a complaint brought by the Centerville Iowegian against Indian Hills Community College.`,
    date: "01/29/2019",
  },
  {
    name: "8 years in, how well does the Iowa Public Information Board work?",
    link: "https://www.desmoinesregister.com/story/news/crime-and-courts/2021/11/27/does-iowa-public-information-board-work-records-open-information-supreme-court/6385612001/",
    description: `In its eight-and-a-half-year existence, the Iowa Public Information Board has levied monetary penalties against public officials who violated the state open records law exactly twice.`,
    date: "11/26/2021",
  },
  {
    name: "Lawyer: Email addresses used by Iowa officials can be secret",
    link: "https://apnews.com/article/a85e089d8678466dabecad96a12205c5",
    description: `A lawyer for the Iowa Public Information Board says agencies can keep secret the personal email addresses used by their board members for official business. More here: https://bleedingheartland.com/static/media/2018/05/IPIBinformalquestion.pdf`,
    date: "05/10/2018",
  },
  {
    name: "Iowa governor: Private meeting by state board ‘probably legal’",
    link: "https://www.desmoinesregister.com/story/news/investigations/2017/08/29/iowa-public-information-boards-private-meeting-probably-legal-reynolds-says/613852001/?hootPostID=006d21d106b24288e916e8a83da705b2",
    description: `A private meeting last week by a state board tasked with enforcing Iowa’s public meetings law was “probably legal,” Gov. Kim Reynolds told reporters Tuesday. The Iowa Public Information Board held the meeting Friday to discuss a case involving an accidental fatal shooting by a Burlington police officer.`,
    date: "08/29/2017",
  },
  {
    name: "Complaints allege Des Moines violated open meetings law",
    link: "https://www.desmoinesregister.com/story/news/local/2017/03/03/complaints-allege-des-moines-violated-open-meetings-law/98699554/?hootPostID=b6138ea4463465fc87a28dc106c8e07d",
    description: `The Iowa Public Information Board has received two complaints alleging the Des Moines City Council violated the state open meetings law last month when it met to discuss pending legislation.`,
    date: "03/03/2017",
  },
  {
    name: "Iowa Public Information Board director resigns, to become Senate secretary",
    link: "https://www.desmoinesregister.com/story/news/2016/11/30/iowa-public-information-board-director-resigns/94679548/",
    description: `Charlie Smithson, the director of the Iowa Public Information Board, has resigned to work as Secretary of the Iowa Senate.`,
    date: "11/30/2016",
  },
  {
    name: "Fired workers’ records can remain secret",
    link: "https://www.desmoinesregister.com/story/news/1/01/01/fired-workers-records-can-remain-secret/3611807/",
    description: `Iowa’s practice of keeping secret some arbitration decisions that uphold or strike down the firings of unionized state workers is legal, according to a ruling from the Iowa Public Information Board.`,
    date: "11/16/2013",
  },
  {
    name: "Ombudsman, IPIB split over openness",
    link: "https://www.desmoinesregister.com/story/news/local/government/1/01/01/ombudsman-board-split-over-openness/3562307/",
    description: `A ruling Thursday by a state board opens the door for Iowa governments to elude a law requiring that the public be given at least 24 hours’ notice before meetings are held, Ombudsman Ruth Cooperrider warned.`,
    date: "11/14/2013",
  },
  {
    name: "Iowa an F grade for public information in 2012 State Integrity Investigation",
    link: "https://publicintegrity.org/politics/state-politics/iowa-governor-cites-state-integrity-investigation-at-bill-signing/",
    description: `In 2012, Iowa got an F grade in the category of "public access to information", prompting the creation of IPIB`,
    date: "03/19/2012",
  },
];
